import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import Paper from "@material-ui/core/Paper";

import Tab from "@material-ui/core/Tab";

import MenuIcon from "@material-ui/icons/Menu";
import "./Header.css";
import { Link } from "react-router-dom";

const Header = props => {
  return (
    <div className="Header">
      <div>
        <img src="/img/top.png" className="Top" />
      </div>
      <div className="Button-container">
        <Link to="/">AUTOS EN STOCK</Link>{" "}
        <img src="/img/divider.png" className="Divider" />
        <Link to="/">¿CÓMO COMPRAR?</Link>{" "}
      </div>
    </div>
  );
};

export default Header;
